






















import Vue from 'vue';
import Component from 'vue-class-component';
import TimelineSurveyForm from './TimelineSurveyForm.vue';
import { BvModalEvent } from 'bootstrap-vue';
import UserInfoController from '@/controllers/UserInfo';
import { TimelineSurveyResponses } from '@/controllers/models/TimelineSurveyResponses';

@Component({components: {TimelineSurveyForm}})
export default class TimelineSurveyPopup extends Vue {
    dontAskAgain = false;
    displayingForm = false;
    
    async okClicked(evt : BvModalEvent)
    {
        evt.preventDefault();
        if (this.displayingForm)
        {
            const form = this.$refs.form as TimelineSurveyForm;
            if (!form) return;
            try
            {
                if (!await form.submit())
                {
                    return;
                }
            }
            catch(err)
            {
                // TODO: Display error
                alert(err);
                return;
            }
        }
        else
        {
            this.displayingForm = true;
            return;
        }
        this.$bvToast.toast("Thank you for your feedback!", { variant: "success" });
        (this.$refs.popupModal as any).hide();
    }

    async cancelClicked()
    {
        const responses = new TimelineSurveyResponses;

        if (this.dontAskAgain)
        {
            responses.howLikelyToRecommend = null;
            responses.howKnowledgeableOrConfident = null;
            responses.howToImprove = null;
            await UserInfoController.SetUserTimelineSurveyResponses(responses);
        }
        else
        {
            this.$bvToast.toast("Okay, we'll check in again next time you share a timeline.", { variant: "primary" });
        }
    }

    async show()
    {
        try
        {
            const resp = await UserInfoController.GetUserTimelineSurveyResponses();
            if (resp) return;
        }
        catch(err)
        {
            // If we get an error, log it and show the popup anyway
            console.error(err);
        }

        (this.$refs.popupModal as any).show();
    }
}
